export enum RadiochemRnDetecModeEnum {
  LIMIT = 'limit',
  THRESHOLD = 'threshold'
}

export enum RadiochemRnDetecUnitEnum {
  BQ_PER_KG = 'bqkg',
  BQ_PER_G = 'bqg',
  BQ_PER_L = 'bql'
}
